import React from 'react';
import classnames from 'classnames';

// Types
import { Attachment } from 'Shared/types/Attachment.type';

const DEFAULT_OPTIONS = {
  controls: true,
};

type Props = {
  attachment: Attachment;
  className?: string;
  options?: {
    controls?: boolean;
  };
};

const AudioPlayer = ({ attachment, className = '', options = DEFAULT_OPTIONS }: Props) => {
  const baseClassName = 'AudioPlayer';
  const classes = classnames(baseClassName, className);

  return (
    <audio controls={options.controls} className={classes}>
      <source src={attachment.url} type={attachment.contentType} />
    </audio>
  );
};

export default AudioPlayer;
